import React, { useState, useEffect } from 'react';
import { LoginForm } from '@/components/auth/LoginForm';
import { RegisterForm } from '@/components/auth/RegisterForm';
import { ForgotPasswordForm } from '@/components/auth/ForgotPasswordForm';
import { useAuth } from '@/contexts/AuthContext';
import { router, AppRoute } from '@/lib/router';

type AuthMode = 'login' | 'register' | 'forgot-password';

export const LoginPage: React.FC = () => {
  const [authMode, setAuthMode] = useState<AuthMode>('login');
  const { isAuthenticated, isLoading } = useAuth();

  // 如果已经登录，重定向到主页
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      router.navigate(AppRoute.HOME);
    }
  }, [isAuthenticated, isLoading]);

  const renderAuthForm = () => {
    switch (authMode) {
      case 'register':
        return (
          <RegisterForm
            onSwitchToLogin={() => setAuthMode('login')}
            onSwitchToForgotPassword={() => setAuthMode('forgot-password')}
          />
        );
      case 'forgot-password':
        return (
          <ForgotPasswordForm
            onSwitchToLogin={() => setAuthMode('login')}
            onSwitchToRegister={() => setAuthMode('register')}
          />
        );
      case 'login':
      default:
        return (
          <LoginForm
            onSwitchToRegister={() => setAuthMode('register')}
            onSwitchToForgotPassword={() => setAuthMode('forgot-password')}
          />
        );
    }
  };

  // 如果正在加载认证状态，显示加载界面
  if (isLoading) {
    return (
      <div className="flex min-h-svh flex-col items-center justify-center bg-muted/40 p-6 md:p-10">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-muted/40 p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-3xl">
        {renderAuthForm()}
      </div>
    </div>
  );
}; 